import { Roles } from '~globals/types/enums';

export const ROLES_DESCRIPTION: Record<Roles, string> = {
  [Roles.Admin]: 'Administrador',
  [Roles.Operator]: 'Operador',
  [Roles.Drive]: 'Chofer',
  [Roles.Reader]: 'Lector',
  [Roles.CreatorOrder]: 'Creador de pedidos',
};
